import styled from 'styled-components'

export const ActivityIndicator = styled.div`
  border-radius: var(--radius-brand);
  padding: var(--space-50) var(--space-100) var(--space-50);

  min-width: 12px;
  min-height: 12px;

  background-color: var(--bg-brand);

  font-size: var(--font-size-100);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-100);
  color: var(--text-on-brand);

  &:empty {
    border-radius: var(--radius-full);
  }
`
